import CryptoJS from 'crypto-js'

export const calculateFileMd5 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = event => {
      const fileContent: any = event?.target?.result
      if (fileContent) {
        const md5 = CryptoJS.MD5(fileContent).toString()
        resolve(md5)
      } else {
        reject(new Error('Failed to read file.'))
      }
    }

    reader.onerror = () => {
      reject(new Error('Failed to read file.'))
    }

    reader.readAsBinaryString(file)
  })
}
